import { render, staticRenderFns } from "./CompanyNote.vue?vue&type=template&id=79d7a877&scoped=true&"
import script from "./CompanyNote.vue?vue&type=script&lang=js&"
export * from "./CompanyNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d7a877",
  null
  
)

export default component.exports